import React from 'react'
import classnames from 'classnames'
import SVGIcon from '@components/SVGIcon'

type StateIndicatorProps = {
  isOpen?: boolean
}

const StateIndicator: React.FC<StateIndicatorProps> = ({ isOpen = false }) => {
  const classname = classnames('state-indicator', {
    'state-indicator--is-open': isOpen,
  })

  return (
    <span className={classname}>
      <SVGIcon xlinkHref="#icons-chevron-down" alt="Chevron down" className="icon" />
    </span>
  )
}

export default StateIndicator
